var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Autocomplete } from '@material-ui/lab';
import { TextField } from '@material-ui/core';
import { useEntityContext } from '../EntityContext';
const EntityDataTypePicker = props => {
    const { error, helperText, index } = props, configProps = __rest(props, ["error", "helperText", "index"]);
    const { entity, column, disabled, onChange } = configProps;
    const context = useEntityContext();
    const { plugins } = context;
    const options = plugins.map(p => p.type);
    const getPlugin = (type) => {
        return plugins.find(plugin => plugin.type === type);
    };
    const plugin = getPlugin(column.type);
    const Configurator = plugin === null || plugin === void 0 ? void 0 : plugin.configurator;
    let type = column.type;
    switch (type) {
        case 'int':
            type = 'integer';
            break;
    }
    const picker = (React.createElement(Autocomplete, { forcePopupIcon: true, disableClearable: true, disabled: disabled, options: options, value: type || 'text', renderInput: params => (React.createElement(TextField, Object.assign({}, params, { fullWidth: true, size: 'small', variant: 'outlined', error: error, helperText: helperText }))), onChange: (_, value) => {
            var _a;
            console.log('onChange value', value);
            let updatedColumn = Object.assign(Object.assign({}, column), { type: value });
            // call previous plugin onChange to remove any configurations
            updatedColumn =
                ((_a = plugin === null || plugin === void 0 ? void 0 : plugin.onRemoveColumnType) === null || _a === void 0 ? void 0 : _a.call(plugin, updatedColumn, index, context)) ||
                    updatedColumn;
            const newPlugin = plugins.find(p => p.type === value);
            if (newPlugin === null || newPlugin === void 0 ? void 0 : newPlugin.onSetColumnType) {
                updatedColumn = newPlugin.onSetColumnType(updatedColumn, index, context);
            }
            // save changes if no configurator
            onChange(updatedColumn);
        } }));
    return Configurator ? (React.createElement(Configurator, Object.assign({ picker: picker, index: index }, configProps))) : (picker);
};
export default EntityDataTypePicker;
//# sourceMappingURL=EntityDataTypePicker.js.map